import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme, { safe }) => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.COLOR_BG_BASE,
    flexGrow: 1,
    paddingBottom: safe.bottom + rh(16),
    paddingHorizontal: theme.SIZE_CONTAINER_PADDING,
    paddingTop: safe.top + rh(64),
    rowGap: rh(32),
  },
  errorBlock: { width: '100%', gap: rh(16) },
  close: {
    position: 'absolute',
    right: rw(24),
    top: safe.top + rh(12),
    zIndex: 1,
    height: rh(40),
    width: rw(40),
    borderRadius: rw(20),
    backgroundColor: theme.COLOR_BG_SURFACE,
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleBlock: {
    alignItems: 'center',
    rowGap: rh(8),
    width: '100%',
  },
  label: {
    color: theme.COLOR_TEXT_SECONDARY,
    fontSize: rf(16),
    lineHeight: rh(22),
  },
  amount: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(48),
    letterSpacing: rw(-1.44),
    lineHeight: rh(53),
  },
  qrCard: {
    alignItems: 'center',
    gap: rh(24),
    width: '100%',
  },
  divider: {
    backgroundColor: theme.COLOR_STROKE_SECONDARY,
    height: rh(1),
    width: '100%',
  },
  phoneBlock: {
    alignItems: 'center',
    rowGap: rh(16),
    width: '100%',
  },
  phoneCaptionRow: {
    alignItems: 'center',
    columnGap: rw(8),
    flexDirection: 'row',
  },
  phoneInfo: {
    alignItems: 'center',
    rowGap: rh(4),
  },
  phone: {
    color: theme.COLOR_TEXT_PRIMARY,
    fontSize: rf(18),
    lineHeight: rh(22),
    textAlign: 'center',
  },
  note: {
    color: theme.COLOR_TEXT_SECONDARY,
    fontSize: rf(13),
    lineHeight: rh(18),
    textAlign: 'center',
  },
  buttonsBlock: {
    marginTop: 'auto',
    rowGap: rh(16),
    width: '100%',
  },
}))
